import React from 'react';
import MyNavbar from "../../../components/student/mynavbar/MyNavbar";
import BlogTittle from "./BlogTittle";
import Hero from "../../../screens/student/blogs/Hero";
import StoriesSection from './StoriesSection';
import LatestBlogs from '../../../subscreens/student/LatestBlogs';
import NewStory from './NewStory';
import BlogsPage from './BlogPage';
import Footer from '../../../components/student/footer/Footer';

const Blogs= () => {
    return(
      <div>
        <MyNavbar/>
        <BlogTittle/>
        <Hero/>
        <NewStory/>

        <div id="latest-blogs">
          <LatestBlogs />
        </div>

        <div id="success-stories">
          <StoriesSection/>
        </div>

        {/* <BlogsPage/> */}
        <Footer/>
      </div>
    );
}

export default Blogs;